











import Main from './components/Main.vue';
import { Component, Vue } from 'vue-property-decorator';
import { Action, State, Mutation } from 'vuex-class';
import { TokenData } from '@/services/loginService';
import tokenService from '@/services/tokenService';
import jwt_decode from 'jwt-decode';


@Component({
  components: {
    Main,
  },
})
export default class App extends Vue {
@Action private login!: any;
@Mutation public setGlobalLanguage: any;
@Mutation public setError: any;

public created() {

    tokenService.clearToken();

    try {

        this.login({ i18n: this.$i18n, accessKey: this.$route.query.t.toString() });

        const tkdata: TokenData = jwt_decode(this.$route.query.t.toString());

        this.setGlobalLanguage(tkdata.idioma);

    } catch (err) {
        this.setError(401, 'login-invalido');
    }
  }
}
